var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginIsShow),expression:"loginIsShow"}],staticClass:"body"})
}
var staticRenderFns = []

export { render, staticRenderFns }